import config from '../../config';
import CookieHelper from './CookieHelper';
import LocalStorageHelper from './OldLocalStorageHelper';
import CustomerHelper from './CustomerHelper';
import OldErrorHandlerHelper from './OldErrorHandlerHelper';

class OldFetchHelper {
  // used by the partnershopmethods
  static didFetchPartnerData = false;
  static fetchingPartnerDataPromise = false;

  async errorResponse(err) {
    const errResponse = {
      error: `ERR_UNKNOWN`,
      message: window.vueHeader.errorUnknown,
      success: false,
    };
    if(err.toString().indexOf(`Failed to fetch`) >= 0) {
      errResponse.message = window.vueHeader.errorConnection;
    }
    // TODO.RIN: send unknown errors e.g. to some logging api
    if(errResponse.error !== `ERR_UNKNOWN`) {
      window.$swal(``, errResponse.message, `error`);
    }
    return errResponse;
  }

  async delete(fetchConfig) {
    const { localFetchConfig, url } = await this.prepareFetchConfig(fetchConfig, `DELETE`);

    return fetch(url, localFetchConfig)
      .then(response => { return response.json(); })
      .then(response => { return response; })
      .catch(err => this.errorResponse(err));
  }

  async handleError(error, message) {
    if(error === `ERR_UNAUTHORIZED`) {
      LocalStorageHelper.removeAll();
      CookieHelper.removeAuthToken();
      CookieHelper.removeCartSession();
      await CustomerHelper.logout(); // clean up existing cookies/ls entries when token is invalid
      OldErrorHandlerHelper.handleError(message, { logToConsole: true });
      try {
        const url = `${config.wpUrls.restapi.path}${config.wpUrls.restapi.endpoints.urls}?pageid=1633`; // 1633 german login/registration
        const fetchResult = await fetch(url, { method: `GET` });
        const result = await fetchResult.json();
        window.location.href = result[CookieHelper.getLanguage()].url;
      } catch (err) {
        OldErrorHandlerHelper.handleError(err, { logToConsole: true });
      }
    }
  }

  async get(fetchConfig) {
    const { localFetchConfig, url } = await this.prepareFetchConfig(fetchConfig, `GET`);
    return fetch(url, localFetchConfig)
      .then(response => { return response.json(); })
      .then(response => {
        if(!response.success) {
          this.handleError(response.error, response.message);
        }

        const internalResponse = response;
        internalResponse.timestamp = Date.now(); // set current time to response
        return internalResponse;
      })
      .catch(err => this.errorResponse(err));
  }

  async patch(fetchConfig) {
    const { localFetchConfig, url } = await this.prepareFetchConfig(fetchConfig, `PATCH`);

    return fetch(url, localFetchConfig)
      .then(response => { return response.json(); })
      .then(response => {
        if(!response.success) {
          this.handleError(response.error, response.message);
        }

        return response;
      }).catch(err => this.errorResponse(err));
  }

  async post(fetchConfig) {
    const { localFetchConfig, url } = await this.prepareFetchConfig(fetchConfig, `POST`);

    return fetch(url, localFetchConfig)
      .then(response => { return response.json(); })
      .then(response => {
        if(!response.success) {
          this.handleError(response.error, response.message);
        }

        return response;
      }).catch(err => this.errorResponse(err));
  }

  async put(fetchConfig) {
    const { localFetchConfig, url } = await this.prepareFetchConfig(fetchConfig, `PUT`);

    return fetch(url, localFetchConfig)
      .then(response => { return response.json(); })
      .then(response => {
        if(!response.success) {
          this.handleError(response.error, response.message);
        }
        return response;
      }).catch(err => this.errorResponse(err));
  }

  async prepareFetchConfig(fetchConfig, method) {
    const localFetchConfig = {};
    if(fetchConfig.headers) {
      localFetchConfig.headers = fetchConfig.headers;
    }
    if(!fetchConfig.ignoreCredentials) {
      localFetchConfig.credentials = `include`;
    }
    localFetchConfig.headers = await this.setContentType(localFetchConfig.headers, fetchConfig);
    localFetchConfig.method = method;

    if(fetchConfig.body) localFetchConfig.body = await this.stringifyBody(fetchConfig);

    const url = await this.setFetchUrl(fetchConfig);

    return { localFetchConfig, url };
  }

  // set the content type, defaults to application/json
  setContentType(headers, fetchConfig) {
    if(fetchConfig.ignoreContentType) {
      return { ...headers };
    }
    if(fetchConfig.contentType) {
      return { ...headers, 'Content-Type': fetchConfig.contentType };
    }
    return { ...headers, 'Content-Type': `application/json` };
  }

  async setFetchUrl(fetchConfig) {
    const baseurl = fetchConfig.baseURL || config.api.baseurl;
    return fetchConfig.path ? baseurl + fetchConfig.path : config.api.baseurl;
  }

  // JSON.stringify body if NOT explicitly set to false
  stringifyBody(fetchConfig) {
    if(fetchConfig.json || fetchConfig.json === null || fetchConfig.json === undefined) {
      return JSON.stringify(fetchConfig.body);
    }
    return fetchConfig.body;
  }

  async isOrderSwitchActiveForRoute(url, httpMethod) {
    try {
      const data = await this.get({
        path: `${config.api.paths.configs.basepath}${config.api.paths.configs.paths.ordersSwitchActive}`,
      });

      return data[url] && data[url].indexOf(httpMethod) >= 0;
    } catch (err) {
      OldErrorHandlerHelper.handleError(err, { logToConsole: true });
      return false;
    }
  }

  async changePathIfOrdersSwitchIsActive(url, httpMethod) {
    const ordersSwitchActive = await this.isOrderSwitchActiveForRoute(url, httpMethod);
    if(ordersSwitchActive) {
      return `${config.api.paths.orders.basepath}${url}`;
    }
    return url;
  }
}

export default new OldFetchHelper();
